// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


import TagList from 'components/TagList'
import { captureExceptions } from 'utils/SentryHelpers'

import PropTypes from 'prop-types'

import 'styles/components/GlobalSearch/ResultPreview/Conversation.styl'

const ResultPreviewConversation = React.createClass({
  displayName: 'ResultPreviewConversation',

  propTypes() { return {
    conversation: PropTypes.object.isRequired
  } },

  render() {
    return (
      <div className="ResultPreviewConversation">
        <div className="subject">
          {this.props.conversation.subject || 'Conversation'}
        </div>
        <div className="body">
          {this.props.conversation.preview}
        </div>
        <div className="bottom">
          <div className="tag-list">
            <TagList tagIds={this.props.conversation.tags} />
          </div>
          <div className={`status ${this.props.conversation.status}`}>
            {this.props.conversation.status}
          </div>
        </div>
      </div>
    )
  }
})

export default Marty.createContainer(ResultPreviewConversation, {
  listenTo: ['stores.TagStore'],

  fetch: {
    selectedTags() {
      return this.app.stores.TagStore.getOrFetchTagIdsForConversationId(this.props.conversation.id)
    },

    allAvailableTagsById() {
      return this.app.stores.TagStore.getOrFetchConversationTagList()
    }
  },

  failed(errors) {
    captureExceptions(errors)
    return <div />
  }
})



// WEBPACK FOOTER //
// ./src/scripts/components/GlobalSearch/ResultPreview/Conversation.js